var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 45,
    viewBox: "0 0 56 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5001 35C11.3808 35 8.38928 33.8147 6.18359 31.705C3.97791 29.5952 2.73877 26.7337 2.73877 23.75C2.73877 20.7663 3.97791 17.9048 6.18359 15.7951C8.38928 13.6853 11.3808 12.5 14.5001 12.5C15.2368 9.21795 17.392 6.33371 20.4916 4.48179C22.0263 3.56481 23.7467 2.92887 25.5546 2.61028C27.3624 2.29169 29.2222 2.2967 31.0279 2.625C32.8336 2.95331 34.5497 3.59848 36.0784 4.5237C37.607 5.44892 38.9182 6.63605 39.937 8.01732C40.9559 9.39859 41.6625 10.947 42.0165 12.574C42.3705 14.201 42.3649 15.8749 42.0001 17.5H44.5001C46.8208 17.5 49.0464 18.4219 50.6873 20.0628C52.3283 21.7038 53.2501 23.9294 53.2501 26.25C53.2501 28.5706 52.3283 30.7962 50.6873 32.4372C49.0464 34.0781 46.8208 35 44.5001 35H42.0001M19.5002 27.5L27.0002 20M27.0002 20L34.5002 27.5M27.0002 20V42.5",
    stroke: "#CCCCCC",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpload);
export default __webpack_public_path__ + "static/media/CloudUpload.a126fd23553fad55654908276eca9eca.svg";
export { ForwardRef as ReactComponent };